<section class="therapy-plan-details-page">
  <div class="row g-3">
    <div class="col-12">
      <div class="sana-card">
        <div class="sana-card-header mb-0">
          <a
            class="back-hint"
            role="link"
            [routerLink]="['../../..']"
            tabindex="0">
            <i class="pi pi-chevron-left"></i> Zurück zur Übersicht
          </a>
        </div>

        @if (isClientLoaded() && isTherapyPlanLoaded()) {
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        } @else {
          <sana-tp-sekeleton-loading></sana-tp-sekeleton-loading>
        }
      </div>
    </div>
  </div>
</section>

<ng-template #content>
  <div class="sana-card-header mb-0">
    {{ selectedTherapyPlan()?.title! }}
  </div>

  <div class="sana-card-body">
    <div class="row sub-info gx-0 mt-2">
      <div class="col-auto">
        {{ selectedTherapyPlan()!.startDate | date:'dd.MM.yyyy' }} - {{ selectedTherapyPlan()!.endDate | date:'dd.MM.yyyy' }}
      </div>
      |
      <div class="col-auto">
        {{ selectedTherapyPlan()!.expectedAmountOfTrainingsPerWeek }} mal pro Woche
      </div>
      @if (selectedTherapyPlan()?.diagnosisNames) {
        |
        <div class="col-auto">
          {{ selectedTherapyPlan()?.diagnosisNames }}
        </div>
      }
    </div>

    <div class="mt-2">
      <small class="sub-info">
        Gesamter Fortschritt:
      </small>

      <div class="mt-2">
        <p-progress-bar
          [value]="therapyPlanProgress()!.therapyPlanProgress"
          [color]="'#1f677a'"></p-progress-bar>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <sana-tp-exercise-therapy-plan-list
      [therapyPlan]="selectedTherapyPlan()!"
      [exercisesInTherapyPlanList]="selectedTherapyPlan()!.therapyPlanExercises"
      [progress]="therapyPlanProgress()!"></sana-tp-exercise-therapy-plan-list>
  </div>

  @if (selectedTherapyPlan()!.status === TherapyPlanStatusEnum.Started) {
    <div class="d-flex justify-content-end">
      <p-button
        severity="contrast"
        label="Abschließen"
        icon="pi pi-times-circle"
        size="small"
        (click)="updateTherapyPlanStatus(TherapyPlanStatusEnum.Finished)"
        [fluid]="false" />
    </div>
  }
</ng-template>
